/* eslint-disable import/prefer-default-export */
export const redirectMap = {
  "/services/safe-deployment": "/services/solution/safe-deployment",
};
